import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { ControlledSearchSelectGroup } from './ControlledSearchSelectGroup';
import { IField } from './IField';

// PLA-1055: al aprobar una contract version los campos que cambiaron se marcan con
// `input--change-indicated` (outline azul entrecortado). Este componente se saltaba la
// marca, así que puertos/bodega cambiados se veían idénticos a los intactos.
const buildField = (changeIndicated: boolean): IField => ({
  name: 'destination_port_id',
  enabled: false,
  readonly: true,
  visible: true,
  changeIndicated,
  options: [{ id: 103, name: 'Auckland' }],
  value: '103',
});

const render = (field: IField) =>
  ReactDOMServer.renderToStaticMarkup(
    <ControlledSearchSelectGroup
      field={field}
      label='Puerto de destino'
      placeholder='Seleccione un puerto…'
      name='contract[destination_port_id]'
    />
  );

describe('ControlledSearchSelectGroup', () => {
  it('marca el campo cuando cambió en esta versión', () => {
    expect(render(buildField(true))).toContain('input--change-indicated');
  });

  it('no lo marca cuando no cambió', () => {
    expect(render(buildField(false))).not.toContain('input--change-indicated');
  });
});
